<template>
    <modal name="coma-test" width="80%" height="auto" :max-width="1100" :adaptive="true" :scrollable="true" @before-close="beforeClose">
        <iframe :src="testUrl" width="100%" height="800" class="modal-coma-test"></iframe>
        <TotemButton icon="cancel" @click="$modal.hide('coma-test')" class="modal-coma-test__close-button" :label="$t('General.close')" />
    </modal>
</template>

<script>
    export default {
        name: 'modal-test-course',
        props: {
            testUrl: String
        },
        methods: {
            async beforeClose (event) {
                await this.$store.dispatch('CompletedCourses/loadCertificates')
                await this.$store.dispatch('CompletedCourses/setReloadLearningPathsState', true)
            }
        },
        data () {
            return {
                error: null,
                model: {
                    email: null,
                    password: null,
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.modal-coma-test {
    border: 0;

    &__close-button {
        margin: 20px auto;
        display: flex;
        align-items: center;
    }
}
</style>
